import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, Control, TextValues } from './oregon-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-oregon',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './oregon.component.html',
  styleUrl: './oregon.component.scss',
})
export class OregonComponent extends UimuiBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('oregon', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('oregon', null);
    }
  }

  onSelect(selectionId: string, formControlName: string): void {
    if (selectionId.includes('IndividualState')) {
      if (
        (formControlName === 'CombinedSingleLimit_DropDown' && this.reactiveForm.get('CombinedSingleLimit_DropDown').valid) ||
        (formControlName === 'SplitLimits_DropDown' && this.reactiveForm.get('SplitLimits_DropDown').valid)
     ) {
        if (this.reactiveForm.get('levelTwo_UM_Radio').value == null) {
            this.reactiveForm.get('levelTwo_UM_Radio').setValue('Limits_LevelTwo_UM_Radio');
        }
      }
    }
  }

  /**
     * Handles dropdown selection and calculates premium when needed
     * @param control - The control object
     * @param event - The selection event containing the selected item
     */
  
    override getLookupControlName(control: Control): string | undefined {
  
      return 'CombinedSingleLimit_DropDown';
    }

    override setupHookForDropDownData() {
      this.setupHookForLiabilityDropDownData();
    }
}
